import { WorkflowStage } from '../types/workflow';

export const WORKFLOW_STAGES: Record<string, WorkflowStage> = {
  INITIAL_REQUEST: {
    id: 'INITIAL_REQUEST',
    name: 'Initial Request',
    description: 'New funding or payment request submission',
    requiredDocuments: [
      {
        id: 'W9',
        name: 'W-9 Form',
        description: 'IRS W-9 form for tax identification purposes',
        type: 'W9',
        required: true,
        validationRules: [
          {
            id: 'W9_COMPLETE',
            type: 'DOCUMENT',
            condition: async (data) => {
              // Validation logic will go here
              return true;
            },
            errorMessage: 'W-9 must be complete and valid',
            severity: 'ERROR'
          }
        ],
        retentionPeriod: 7,
        irsRequirement: true
      }
    ],
    requiredApprovals: [],
    automatedChecks: [
      {
        id: 'OFAC_CHECK',
        name: 'OFAC Compliance Check',
        type: 'ANTI_TERRORISM',
        description: 'Verify against OFAC database',
        validation: async (data) => {
          // Validation logic will go here
          return { valid: true, timestamp: new Date() };
        },
        frequency: 'ONCE'
      }
    ],
    nextStages: ['INITIAL_REVIEW'],
    previousStages: [],
    escalationTriggers: [
      {
        id: 'TIME_IN_STAGE',
        condition: 'TIME',
        threshold: 48, // hours
        escalateTo: ['FISCAL_MANAGER'],
        action: 'NOTIFY'
      }
    ]
  },
  // ... Additional stages ...
};

export const COMPLIANCE_RULES = {
  IRS: {
    documentRetention: {
      W9: 7, // years
      INVOICES: 7,
      GRANT_AGREEMENTS: 7,
      TAX_RETURNS: 7
    },
    expenditureResponsibility: {
      thresholds: {
        requiresReport: 5000,
        requiresBoardApproval: 25000
      }
    }
  },
  FISCAL: {
    approvalThresholds: {
      PROGRAM_MANAGER: 1000,
      FISCAL_MANAGER: 10000,
      EXECUTIVE_DIRECTOR: 50000,
      BOARD: 100000
    }
  }
}; 